import { tokenStorage } from './tokenStorage';
import { setJwtToken, logoutUser } from '../store/slices';

let broadcastChannel = null;
let storeDispatch = null;

/**
 * Initialize broadcast channel for token sync across tabs
 * @param {Function} dispatch - Redux dispatch function
 */
export const initTokenBroadcast = (dispatch) => {
  storeDispatch = dispatch;

  if (typeof BroadcastChannel !== 'undefined') {
    broadcastChannel = new BroadcastChannel('auth-tokens');

    broadcastChannel.onmessage = (event) => {
      if (event.data.type === 'TOKEN_UPDATE') {
        const { accessToken, expiresIn } = event.data;
        tokenStorage.saveAccessToken(accessToken, expiresIn);
        if (storeDispatch) {
          storeDispatch(setJwtToken({ token: accessToken }));
        }
      } else if (event.data.type === 'LOGOUT') {
        tokenStorage.clearTokens();
        if (storeDispatch) {
          storeDispatch(logoutUser());
        }
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    };
  }

  return () => {
    if (broadcastChannel) {
      broadcastChannel.close();
    }
    storeDispatch = null;
  };
};

/**
 * Broadcast token update to other tabs
 */
export const broadcastTokenUpdate = (accessToken, expiresIn) => {
  if (broadcastChannel) {
    broadcastChannel.postMessage({
      type: 'TOKEN_UPDATE',
      accessToken,
      expiresIn,
    });
  }
};

/**
 * Broadcast logout to other tabs
 */
export const broadcastLogout = () => {
  if (broadcastChannel) {
    broadcastChannel.postMessage({
      type: 'LOGOUT',
    });
  }
};
